import React, { useEffect, useState } from 'react';
import { Plus, Pencil, Trash2, Award, Lock } from 'lucide-react';
import { api } from '../api';
import { PageLoading, Modal, useToast, Confirm } from '../components/ui';

export default function Qualifications() {
  const toast = useToast();
  const [list, setList] = useState(null);
  const [edit, setEdit] = useState(null); // {id?, code, name}
  const [del, setDel] = useState(null);

  const load = () => api.get('/qualifications').then((d) => setList(d.qualifications));
  useEffect(() => { load(); }, []);
  if (!list) return <PageLoading />;

  const save = async () => {
    if (!edit.code || !edit.name) return toast('Kürzel und Name erforderlich', 'err');
    try {
      if (edit.id) await api.put(`/qualifications/${edit.id}`, { code: edit.code, name: edit.name });
      else await api.post('/qualifications', { code: edit.code, name: edit.name });
      setEdit(null); load(); toast('Gespeichert');
    } catch (e) { toast(e.message, 'err'); }
  };
  const remove = async (id) => {
    try { await api.del(`/qualifications/${id}`); load(); toast('Gelöscht'); }
    catch (e) { toast(e.message, 'err'); }
  };

  return (
    <>
      <div className="page-head">
        <div><h1>Qualifikationen</h1><div className="sub">Katalog der Qualifizierungsstufen. GF / Ma / CE / AS steuern die Einteilungslogik.</div></div>
        <div className="toolbar"><button className="btn btn-primary" onClick={() => setEdit({ code: '', name: '' })}><Plus size={16} /> Neue Qualifikation</button></div>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table className="table">
            <thead><tr><th>Kürzel</th><th>Bezeichnung</th><th>Typ</th><th></th></tr></thead>
            <tbody>
              {list.map((q) => (
                <tr key={q.id}>
                  <td><span className="qual-tag">{q.code}</span></td>
                  <td>{q.name}</td>
                  <td>{q.is_system ? <span className="badge badge-gray"><Lock size={11} /> System</span> : <span className="badge badge-red">Eigen</span>}</td>
                  <td className="row-actions">
                    <button className="btn btn-secondary btn-sm" onClick={() => setEdit({ id: q.id, code: q.code, name: q.name, is_system: q.is_system })}><Pencil size={14} /></button>
                    {!q.is_system && <button className="btn btn-danger btn-sm" onClick={() => setDel(q)}><Trash2 size={14} /></button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="info-box" style={{ marginTop: 14 }}>
        <Award size={14} style={{ verticalAlign: -2 }} /> <strong>GF</strong> = Wachführer, <strong>Ma</strong> = Maschinist, <strong>CE</strong> = LKW-Führerschein, <strong>AS</strong> = Atemschutzgeräteträger. Diese vier sind fest mit der Einteilungslogik verknüpft; weitere Stufen kannst du frei ergänzen.
      </div>

      {edit && (
        <Modal title={edit.id ? 'Qualifikation bearbeiten' : 'Neue Qualifikation'} onClose={() => setEdit(null)}
          footer={<><button className="btn btn-secondary" onClick={() => setEdit(null)}>Abbrechen</button><button className="btn btn-primary" onClick={save}>Speichern</button></>}>
          <div className="form-group">
            <label>Kürzel {edit.is_system && <span className="muted">(System – nicht änderbar)</span>}</label>
            <input value={edit.code} disabled={edit.is_system} onChange={(e) => setEdit({ ...edit, code: e.target.value })} placeholder="z. B. TF" />
          </div>
          <div className="form-group"><label>Bezeichnung</label><input value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} placeholder="z. B. Truppführer" /></div>
        </Modal>
      )}
      {del && <Confirm text={`Qualifikation „${del.code} – ${del.name}" wirklich löschen?`} onConfirm={() => remove(del.id)} onClose={() => setDel(null)} />}
    </>
  );
}
